import React from 'react';
import { Container } from 'reactstrap';
import i18n from '../utils/i18n';
import StripeFormContainer from '../containers/StripeFormContainer';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';

import './styles/UpdateCardScreen.scss';

const UpdateCard = () => (
  <HeaderContainerTemplate>
    <Container>
      <div className="update-card-screen">
        <h2>
          {i18n.t('payments.UPDATE_CARD')}
        </h2>
        <hr />
        <StripeFormContainer isUpdate={ true } />
      </div>
    </Container>
  </HeaderContainerTemplate>
);

export default UpdateCard;



// WEBPACK FOOTER //
// ./src/scenes/UpdateCard.js